import * as React from 'react';
import { TableCell } from 'types/common/table';
import { RouteText } from 'components/plansales/billing/billingtable/DataTableCellRenderer';
import { paymentMethodName, planTypeName } from 'constants/groups/filter';
import { CLOSETGroupItem, GetCLOSETGroupsListResponse } from '../../types/api/groups/closet';
import { getUtcUsFormatDate } from 'modules/utils/time';
import { NULL_TEXT } from 'constants/common';

export const groupLIstExcelColumns = (data: GetCLOSETGroupsListResponse) => {
  if (!data.items || data.items.length === 0) return [];
  return data.items.map((item, index) => {
    const getPaymentMethod = () => {
      if (!item.paymentMethod) return NULL_TEXT;
      return paymentMethodName[item.paymentMethod];
    };
    const getSubscriptionEndDate = () => {
      if (!item.subscriptionTerm.endDate) return NULL_TEXT;
      return getUtcUsFormatDate(item.subscriptionTerm.endDate);
    };
    return {
      ['No.']: index + 1,
      ['Group ID']: item.groupId.toUpperCase(),
      ['Group Admin Email']: item.groupAdminEmail,
      ['Plan Type']: planTypeName[item.planType],
      ['Payment Method']: getPaymentMethod(),
      ['Subscription Start Date']: getUtcUsFormatDate(item.subscriptionTerm.startDate),
      ['Subscription End Date']: getSubscriptionEndDate(),
      ['Measurement Start Date']: getUtcUsFormatDate(item.measurementPeriodTerm.startDate),
      ['Measurement End Date']: getUtcUsFormatDate(item.measurementPeriodTerm.endDate),
      ['Registered Date']: getUtcUsFormatDate(item.registeredDate),
    };
  });
};

export const groupListColumns = (
  _totalItems: number,
  currentPageIndex: number,
): TableCell<CLOSETGroupItem>[] => {
  return [
    {
      align: 'center',
      name: 'No.',
      key: 'no',
      render: (rowData, columnData, rowIndex) => {
        return (rowIndex + 1) * currentPageIndex;
      },
    },
    {
      align: 'center',
      name: 'Group ID',
      key: 'groupId',
      render: rowData => {
        return (
          <RouteText to={`/groups/${rowData.groupId}`}>{rowData.groupId.toUpperCase()}</RouteText>
        );
      },
    },
    {
      align: 'left',
      name: 'Group Admin Email',
      key: 'groupAdminEmail',
      render: rowData => rowData.groupAdminEmail,
    },
    {
      align: 'center',
      name: 'Plan Type',
      key: 'planType',
      render: (rowData): string => planTypeName[rowData.planType],
    },
    {
      align: 'center',
      name: 'Payment Method',
      key: 'paymentMethod',
      render: rowData => {
        if (!rowData.paymentMethod) return NULL_TEXT;
        return paymentMethodName[rowData.paymentMethod];
      },
    },
    {
      align: 'center',
      name: 'Subscription Start Date',
      key: 'subscriptionStartDate',
      width: 125,
      render: rowData => getUtcUsFormatDate(rowData.subscriptionTerm.startDate),
    },
    {
      align: 'center',
      name: 'Subscription End Date',
      key: 'subscriptionEndDate',
      width: 125,
      render: rowData => {
        if (!rowData.subscriptionTerm.endDate) return NULL_TEXT;
        return getUtcUsFormatDate(rowData.subscriptionTerm.endDate);
      },
    },
    {
      align: 'center',
      name: 'Measurement Start Date',
      key: 'measurementStartDate',
      width: 125,
      render: rowData => getUtcUsFormatDate(rowData.measurementPeriodTerm.startDate),
    },
    {
      align: 'center',
      name: 'Measurement End Date',
      key: 'measurementEndDate',
      width: 125,
      render: rowData => getUtcUsFormatDate(rowData.measurementPeriodTerm.endDate),
    },
    {
      align: 'center',
      name: 'Registered Date',
      key: 'registeredDate',
      width: 125,
      render: rowData => getUtcUsFormatDate(rowData.registeredDate),
    },
  ];
};
